import React from 'react'
import "../HeroHighlights.css";




const HeroHighlights = () => {
    return (
        <>
            <div className="hero-highlights">

                <h3>Empowering Businesses Through Technology</h3>

                <div className="highlight-list">

                    <div className="highlight-item">
                        <span className="check">✓</span>
                        <span>End-to-End Software Development</span>
                    </div>

                    <div className="highlight-item">
                        <span className="check">✓</span>
                        <span>AI & Automation Solutions</span>
                    </div>

                    <div className="highlight-item">
                        <span className="check">✓</span>
                        <span>Agile Development Process</span>
                    </div>

                    <div className="highlight-item">
                        <span className="check">✓</span>
                        <span>Cloud-Native Applications</span>
                    </div>

                    <div className="highlight-item">
                        <span className="check">✓</span>
                        <span>Dedicated Support</span>
                    </div>

                    <div className="highlight-item">
                        <span className="check">✓</span>
                        <span>Secure & Scalable Architecture</span>
                    </div>

                </div>

            </div>
        </>
    )
}

export default HeroHighlights
